const comparePaths = (a: string, b: string) => {
    const partsA = a.split('/');
    const partsB = b.split('/');
    const counter = Math.max(partsA.length, partsB.length);

    for (let index = 0; index < counter; index++) {
        const partA = partsA[index];
        const partB = partsB[index];

        if (partA === partB) {
            continue;
        }

        if (partA === undefined || partB === '*') {
            return -1;
        }

        if (partB === undefined || partA === '*') {
            return 1;
        }

        return partA.localeCompare(partB);
    }

    return 0;
};

export default comparePaths;
